import styled, { css } from "styled-components";
import { typography } from "../../../base/styled/typography.style";
import { colors } from "../../../base/styled/variables.styled";
const linkIconStyle = css `
	${css(typography.linkIcon)}
	text-decoration: underline;
	&::after {
		content: '';
		display: inline-block;
		width: 12px;
		height: 12px;
		background-color: currentColor;
		mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="%23fff" d="M8.78129 5.33336L5.20529 1.75736L6.14796 0.814697L11.3333 6.00003L6.14796 11.1854L5.20529 10.2427L8.78129 6.6667H0.666626V5.33336H8.78129Z"/></svg>');
		mask-repeat: no-repeat;
		mask-size: contain;
		-webkit-mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="%23fff" d="M8.78129 5.33336L5.20529 1.75736L6.14796 0.814697L11.3333 6.00003L6.14796 11.1854L5.20529 10.2427L8.78129 6.6667H0.666626V5.33336H8.78129Z"/></svg>');
		-webkit-mask-repeat: no-repeat;
		-webkit-mask-size: contain;
	}
`;
export const StyledRichText = styled.div.withConfig({
    shouldForwardProp: (prop) => !['inverse', '$inverse'].includes(prop),
}) `
	width: 100%;
	max-width: 1280px;
	margin: 0px auto;
	box-sizing: border-box;

	/* Headlines */
	h1 {
		${css(typography.headline1)}
		${({ $inverse }) => $inverse &&
    css `
				color: ${colors.neutral000};
			`}
	}
	h2 {
		${css(typography.headline2)}
	}
	h3 {
		${css(typography.headline3)}
	}
	h4 {
		${css(typography.headline4)}
	}
	h5 {
		${css(typography.headline5)}
	}
	h6 {
		${css(typography.headline6)}
	}

	/* Subtitles */
	.subtitle1 {
		${css(typography.subtitle1)}
	}
	.subtitle2 {
		${css(typography.subtitle2)}
	}
	.subtitle3 {
		${css(typography.subtitle3)}
	}

	/* Body text */
	p,
	.body1 {
		${css(typography.body1)}
	}
	.body1-highlight {
		${css(typography.body1Highlight)}
	}
	.body2 {
		${css(typography.body2)}
	}
	.body2-highlight {
		${css(typography.body2Highlight)}
	}
	.body3 {
		${css(typography.body3)}
	}
	.body3-highlight {
		${css(typography.body3Highlight)}
	}
	.body4 {
		${css(typography.body4)}
	}
	.body4-highlight {
		${css(typography.body4Highlight)}
	}

	/* Quote */
	blockquote,
	.blockquote {
		${css(typography.quote)}
	}

	/* Legend */
	.legend {
		${css(typography.legend)}
	}
	.legend-highlight {
		${css(typography.legendHighlight)}
	}

	/* Display */
	.display1 {
		${css(typography.display1)}
	}
	.display2 {
		${css(typography.display2)}
	}

	.link-icon {
		${linkIconStyle}
	}
`;
//# sourceMappingURL=RichText.style.js.map